import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { PlayArrow as ArrowIcon } from '@mui/icons-material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import { bindActionCreators, compose } from 'redux';
import { getUrl, withRouter } from '../../utils';
import { styles } from './styles';
import { connect } from 'react-redux';
import { analyticsDataForPackageRequested, analyticsExportForPackageRequested } from '../../stores/analytics/actions';
import { NOTIFICATIONS } from '../../constants/analytics';
import {
    getNotificationsContextForPackage,
    getNotificationsDataForPackage,
    getNotificationsForPackageName,
} from '../../selectors/analytics';
import SoftProDataTable from '../../components/SoftProDataTable';
import { ANALYTICS_ORDER_BY_FIELD_EMAIL } from '../../constants/api';
import { SORT_DESC } from '../../components/DataTable/constants';
import DataTableColumn from '../../components/DataTable/DataTableColumn';
import { ViewButton } from '../../components/ViewButton';
import { ExportButton } from '../../components/ExportButton';
import TablesPropTypes from '../../propTypes/tables';
import EmptyTable from '../../components/EmptyTable';

class NotificationsTable extends React.Component {
    renderEmail = ({ email }) => email;
    renderDate = ({ date }) => date;
    renderViewButton = ({ userId }) => (
        <ViewButton
            onClick={() => this.props.navigate(
                '/admin/users/userDetails/' + userId + '/userEmail',
            )}
        />
    );

    render () {
        const {
            classes,
            tableData,
            tableContext,
            analyticsDataForPackageRequested,
            packageId,
        } = this.props;
        return (
            <SoftProDataTable
                tableData={tableData}
                tableContext={tableContext}
                getKey={({ userId }) => userId}
                onFetchDataRequested={(context) => analyticsDataForPackageRequested(NOTIFICATIONS, packageId, context)}
                renderEmpty={() => <EmptyTable />}
            >
                {({ createOnSort, createSortGetter }) => (
                    <Fragment>
                        <DataTableColumn
                            headCellContent="Email"
                            classes={{ headCell: classes.emailAutoCol, bodyCell: classes.emailAutoCol }}
                            getSort={createSortGetter(ANALYTICS_ORDER_BY_FIELD_EMAIL)}
                            onSort={createOnSort(ANALYTICS_ORDER_BY_FIELD_EMAIL)}
                            initialSort={SORT_DESC}
                        >
                            {this.renderEmail}
                        </DataTableColumn>
                        <DataTableColumn
                            headCellContent="Notification Date"
                            classes={{ headCell: classes.notificationDateCol, bodyCell: classes.notificationDateCol }}
                        >
                            {this.renderDate}
                        </DataTableColumn>
                        <DataTableColumn classes={{ headCell: classes.viewCol, bodyCell: classes.viewCol }}>
                            {this.renderViewButton}
                        </DataTableColumn>
                    </Fragment>
                )}
            </SoftProDataTable>
        );
    }
}

NotificationsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    tableData: TablesPropTypes.tablePageData,
    tableContext: PropTypes.object.isRequired,
    analyticsDataForPackageRequested: PropTypes.func.isRequired,
    packageId: PropTypes.string.isRequired,
};

class NotificationsDetails extends React.Component {
    componentDidMount () {
        const { packageId, analyticsDataForPackageRequested } = this.props;
        analyticsDataForPackageRequested(NOTIFICATIONS, packageId);
    }

    render () {
        const {
            classes,
            navigate,
            tableData,
            tableContext,
            analyticsDataForPackageRequested,
            analyticsExportForPackageRequested,
            loading,
            router,
            name,
            packageId,
        } = this.props;
        const BreadcrumbDivider = () => <ArrowIcon className={classes.arrow} />;
        return (
            <Grid container direction="column" className={classes.root}>
                <Grid container justifyContent="space-between" wrap="nowrap">
                    <Grid container alignItems="center">
                        <Grid item>
                            <Link
                                to="/admin/analytics"
                                className={classes.breadcrumb}
                            >
                                Analytics
                            </Link>
                        </Grid>
                        <Grid item component={BreadcrumbDivider} />
                        <Grid item>
                            <Link
                                to="/admin/analytics/notifications"
                                className={classes.breadcrumb}
                            >
                                Notifications
                            </Link>
                        </Grid>
                        <Grid item component={BreadcrumbDivider} />
                        <Grid item>
                            {loading
                                ? <CircularProgress size={14} />
                                : <Link to={getUrl(window, router)} className={classes.breadcrumb}> {name} </Link>}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <BackButton onClick={() => navigate('/admin/analytics/notifications')} />
                    </Grid>
                </Grid>
                <Grid item>
                    <NotificationsTable
                        tableContext={tableContext}
                        tableData={tableData}
                        classes={classes}
                        navigate={navigate}
                        packageId={packageId}
                        analyticsDataForPackageRequested={analyticsDataForPackageRequested}
                    />
                </Grid>
                <Grid item>
                    <ExportButton
                        loading={loading}
                        onClick={() => analyticsExportForPackageRequested(NOTIFICATIONS, packageId, tableContext)}
                    />
                </Grid>
            </Grid>
        );
    }
}

NotificationsDetails.propTypes = {
    classes: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    tableData: TablesPropTypes.tablePageData,
    tableContext: PropTypes.object.isRequired,
    analyticsDataForPackageRequested: PropTypes.func.isRequired,
    analyticsExportForPackageRequested: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    packageId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        loading: state.analytics.notificationsForPackage.loading,
        tableData: getNotificationsDataForPackage(state),
        tableContext: getNotificationsContextForPackage(state),
        name: getNotificationsForPackageName(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...(bindActionCreators(
            {
                analyticsDataForPackageRequested,
                analyticsExportForPackageRequested,
            },
            dispatch
        )),
    };
};

const NotificationsDetailsFunction = (props) => {
    const { packageId } = useParams();
    const navigate = useNavigate();
    return <NotificationsDetails packageId={packageId} navigate={navigate} {...props} />;
};

export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(NotificationsDetailsFunction);
